<template>
  <div class="text_left his_con">
    <title-bar-back :title="'协商历史'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <!-- 头部信息 -->
    <div v-for="(item, index) in getNegotiationHistory" :key="index">
      <div v-if="index < getNegotiationHistory.length - 1" class="font_top">
        <div class="clearfix">
          <img
            :src="require(`@/assets/${$G('@/')}order/az_logo@2x.png`)"
            alt=""
            class="top_logo left"
          />
          <div class="left top_right">
            <div class="right_name">系统</div>
            <div class="right_time">
              {{ item.gmtCreate | dateFormatterJava("YYYY-MM-DD HH:mm:ss") }}
            </div>
          </div>
        </div>
        <div class="bottom_top">{{ item.operateNote }}</div>
        <div class="bottom_bot det_mar">
          {{ item.tips }}
        </div>
        <div v-if="false">
          <div class="det_det">寄回地址：</div>
          <div v-if="true" class="det_det">收货人：111</div>
          <div v-if="true" class="det_det">电话：1111</div>
          <div v-if="true" class="det_det">收货地址：11111</div>
        </div>
      </div>
      <!-- 退款信息 -->
      <div v-if="index === getNegotiationHistory.length - 1" class="detail_det">
        <div class="clearfix">
          <img :src="item.creatorPic" alt="" class="top_photo left" />
          <div class="left top_right">
            <div class="right_name font_top1">{{ item.creator }}</div>
            <div class="right_time">
              {{ item.gmtCreate | dateFormatterJava("YYYY-MM-DD HH:mm:ss") }}
            </div>
          </div>
        </div>
        <div class="bottom_top bottom_top1 font_top1">
          买家({{ item.creator }})于{{
            item.gmtCreate | dateFormatterJava("YYYY-MM-DD HH:mm:ss")
          }}创建了退款申请
        </div>
        <div class="det_det">
          退款类型：{{ $route.query.afterSaleTyp === 0 ? "退款" : "退货退款" }}
        </div>
        <div class="det_det">
          退款金额：{{ $route.query.returnPrice | currency(false) }}
        </div>
        <div class="det_det">退款原因：{{ $route.query.reason }}</div>
        <div class="det_det">退款说明：{{ $route.query.instruction }}</div>
      </div>
    </div>
    <div class="mar-bar" />
    <!-- 联系客服 -->
    <div class="call_service">
      <pharmacist-btn-all />
    </div>
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
const PharmacistBtnAll = () =>
  import("@/components/PharmacistBtnAll").then(m => m.default || m);
export default {
  name: "RefundHistory",
  components: {
    TitleBarBack,
    PharmacistBtnAll
  },
  filters: {
    status(status) {
      switch (status) {
        case 1:
          return "审核中";
        case 2:
          return "待商品寄回";
        case 3:
          return "待商家收货";
        case 4:
          return "待财务审核";
        case 5:
          return "退款中";
        case 6:
          return "售后成功";
        case 7:
          return "售后驳回";
        case 8:
          return "撤销售后";
      }
    },
    kindType(kind) {
      switch (kind) {
        case 0:
          return "只退款";
        case 1:
          return "退款退货";
      }
    }
  },
  computed: {
    getNegotiationHistory() {
      return this.$store.getters.getNegotiationHistory;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    back() {
      this.$router.back();
    },
    // getNegotiationHistory
    getData() {
      this.$store
        .dispatch("order/getNegotiationHistory", {
          params: { id: this.$route.query.id }
        })
        .then(() => {})
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.his_con {
  font-size: 0;
}
.title_right {
  width: 36px;
}
/* 退款信息 */
.detail_det {
  margin-top: 10px;
  padding: 15px;
  background: #fff;
  font-size: 14px;
}
.det_det {
  font-size: 14px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 22px;
  margin-bottom: 1px;
}
.det_mar {
  margin-bottom: 10px;
}
/* 头部信息 */
.font_top {
  background: #fff;
  padding: 12px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 20px;
  margin-top: 10px;
}
.font_top1 {
  background: #fff;
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 20px;
}
.top_logo {
  width: 36px;
}
.top_right {
  padding-left: 10px;
}
.right_time {
  padding-top: 4px;
  font-size: 12px;
  color: rgba(153, 153, 153, 1);
  line-height: 16px;
}
.bottom_top {
  padding-top: 10px;
}
.bottom_top1 {
  padding-bottom: 8px;
}
.bottom_bot {
  padding-top: 5px;
}
.top_photo {
  display: block;
  width: 36px;
  height: 36px;
  border-radius: 5px;
}
.mar-bar {
  height: 60px;
}
/* 联系客服 */
.call_service {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: #fff;
  font-size: 15px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 50px;
  text-align: center;
}
.call_service img {
  width: 24px;
  height: 24px;
  vertical-align: middle;
  margin-right: 8px;
}
.ser_f {
  vertical-align: middle;
}
</style>
